import React from 'react'
import { useFormContext } from 'react-hook-form';
import axios from 'axios'
import '../style.css'

const Input = ({ element, input }: any) => {
  // Requisição dos dados dos componentes Input
  const [optionList, setOptionList] = React.useState<any[]>([])
  const [optionClicked, setOptionClicked] = React.useState(false)
  const [loadSelector, setLoadSelector] = React.useState(true)
  // Bloquear o first load do useLayoutEffect
  const firstUpdate = React.useRef(true);
  React.useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    if (optionClicked === true) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/${element.apiUrl}`)
        .then((response) => {
          const data = response.data
          setOptionList([data])
          setLoadSelector(false)
        })

    }
  }, [optionClicked, element.apiUrl])
  //  useRef do elemento input, para quando for editar algum vinho e reusar a página Input
  const inputActiveRef = React.useRef<any>(null)
  React.useEffect(() => {
    if (input !== undefined) {
      if (inputActiveRef.current !== null) {
        inputActiveRef.current.lastElementChild.focus()
        inputActiveRef.current.lastElementChild.value = input
        window.scrollTo(0,0)      
      }
    }
  }, [input])
  // ...
  const { register, formState: { errors } } = useFormContext();
  // ...
  return (
    <div ref={inputActiveRef}>
      {/* Input */}
      <label className="w-full text-opacity-75 whitespace-nowrap" htmlFor={element.id}>
        {element.name}
      </label>
      {/* , { required: "Item necessário" } */}
      {
        (element.type !== "option") ?
          (
            <input id={element.id} className="w-full bg-dark-1 text-white focus:outline-none p-1 px-4 input-form whitespace-nowrap" type={element.type} step={element.step} style={{
            }} {...register(`${element.id}`, (element.required && { required: "Item necessário" }))}
            />
          )
          :
          (
            <select onClick={() => setOptionClicked((optionClicked) => !optionClicked)} id={element.id} className="w-full bg-dark-1 text-white focus:outline-none  p-1 whitespace-nowrap select-form"  {...register(`${element.id}`, (element.required && { required: "Item necessário" }))}>
              {(input === undefined) ? (
                (loadSelector === true)
                  ? (<option disabled>Loading...</option>)
                  : <option disabled>Selecione</option>

              ) : (<option >{input}</option>)
              }
              {(optionList.length > 0) &&
                (Object.values(optionList[0]).map((option: any) => {
                  if (input !== option[Object.keys(option)[1]]) {
                    return (
                      <option key={option[Object.keys(option)[0]]}>{option[Object.keys(option)[1]]}</option>
                    )
                  } else {
                    return null
                  }
                }
                ))
              }
            </select>
          )
      }
      {/* Error */}
      {(errors[element.id]) && (<p className="text-red-500 whitespace-nowrap">{errors[element.id].message}</p>)}

    </div>
  )
}

export default Input
